'use strict';

var EditLte = require('actionGroups/editLte/EditLte');

module.exports = {
  Model: EditLte,
};
